import { useCallback, useMemo, useState } from 'react';

const defaultState = {
  open: false,
  title: '',
  description: '',
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel',
  isDestructive: false,
  onConfirm: null,
  onCancel: null,
  children: null
};

export default function useConfirmDialog() {
  const [dialogState, setDialogState] = useState(defaultState);
  const [confirming, setConfirming] = useState(false);

  const openConfirm = useCallback((config) => {
    setDialogState({
      ...defaultState,
      ...config,
      open: true
    });
  }, []);

  const handleCancel = useCallback(() => {
    if (confirming) return;
    if (dialogState.onCancel) {
      dialogState.onCancel();
    }
    setDialogState((prev) => ({ ...prev, open: false }));
  }, [confirming, dialogState]);

  const handleConfirm = useCallback(async () => {
    if (!dialogState.onConfirm) {
      setDialogState((prev) => ({ ...prev, open: false }));
      return;
    }

    setConfirming(true);
    try {
      await dialogState.onConfirm();
    } finally {
      setConfirming(false);
      setDialogState((prev) => ({ ...prev, open: false }));
    }
  }, [dialogState]);

  const confirmDialogProps = useMemo(() => ({
    ...dialogState,
    loading: confirming,
    onConfirm: handleConfirm,
    onCancel: handleCancel
  }), [dialogState, confirming, handleCancel, handleConfirm]);

  return {
    confirmDialogProps,
    openConfirm
  };
}
